import { render, staticRenderFns } from "./Svg-icon.vue?vue&type=template&id=4b4cc557&"
import script from "./Svg-icon.vue?vue&type=script&lang=ts&"
export * from "./Svg-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports